import $ from 'jquery';

const modalFunctions = {
  setFormAttr: function (formModal, formFocusableEls) {
    if (formModal.length != 0) {
      formFocusableEls.each(function () {
        $(this).attr('tabindex', '-1');
      });
    }
  },

  openModal: function (e, modalArgs) {
    e.preventDefault();
    $('.hero-nl-video video').length !== 0
      ? $('.hero-nl-video video').get(0).pause()
      : '';
    modalArgs.mainContentFocusableEls.each(function () {
      $(this).attr('tabindex', '-1');
    });
    modalArgs.headerContentFocusableEls.each(function () {
      $(this).attr('tabindex', '-1');
    });
    modalArgs.footerContentFocusableEls.each(function () {
      $(this).attr('tabindex', '-1');
    });
    modalArgs.formFocusableEls.each(function () {
      $(this).attr('tabindex', '0');
    });
    modalArgs.formModal
      .fadeIn()
      .addClass('opened')
      .attr('aria-hidden', 'false');
    modalArgs.formModal.find("input[name='firstname']").focus();
    modalArgs.htmlEL.addClass('hidden');
  },

  closeModal: function (modalArgs) {
    $('.hero-nl-video video').length !== 0
      ? $('.hero-nl-video video').get(0).play()
      : '';
    modalArgs.formModal
      .fadeOut()
      .removeClass('opened')
      .attr('aria-hidden', 'true');
    modalArgs.htmlEL.removeClass('hidden');
    modalArgs.mainContentFocusableEls.each(function () {
      $(this).attr('tabindex', '0');
    });
    modalArgs.headerContentFocusableEls.each(function () {
      $(this).attr('tabindex', '0');
    });
    modalArgs.footerContentFocusableEls.each(function () {
      $(this).attr('tabindex', '0');
    });
    modalArgs.formFocusableEls.each(function () {
      $(this).attr('tabindex', '-1');
    });
  },
};
export default modalFunctions;
